import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import potSauce from "@/assets/products/pot-sauce-single.png";
import potSauceLifestyle from "@/assets/products/pot-sauce-lifestyle.png";

const config: ProductPageConfig = {
  name: "Pots à sauce avec couvercle",
  breadcrumbName: "Pots à sauce",
  subtitle: "Petits pots pour sauces, condiments et accompagnements",
  features: ["Contact alimentaire", "Couvercle inclus", "Étanche", "Disponible en stock"],
  variants: [
    { capacity: "30 ml", material: "Plastique PP", packaging: "Carton de 500 (10 x 50)", palette: "180 cartons", image: potSauce },
    { capacity: "60 ml", material: "Plastique PP", packaging: "Carton de 500 (10 x 50)", palette: "112 cartons", image: potSauce },
  ],
  lifestyleImages: [
    { src: potSauceLifestyle, caption: "Idéal pour accompagner burgers et frites" },
  ],
};

const PotSauce = () => <ProductPageLayout config={config} />;
export default PotSauce;
